import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/github/workspace/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const TextBlock = makeShortcode("TextBlock");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <TextBlock slots="heading, text" width="100%" theme="lightest" alignment="yes" paddingBottom='5' className="py-confirmation div-p-0 left-content how-it-work-richText confirmation-heading confirmation-h-pad" mdxType="TextBlock" />
    <h2 {...{
      "id": "thank-you-for-contacting-us"
    }}>{`Thank you for contacting us.`}</h2>
    <p>{`An Adobe expert will be reaching out within the next few business days.`}</p>
    <TextBlock slots="text" width="100%" theme="lightest" alignment="yes" paddingTop="5" paddingBottom='5' className="py-0 div-p-0 left-content link linking how-it-work-richText support-explore-content confirmation-h-pad" mdxType="TextBlock" />
    <p>{`Meanwhile, we encourage you to explore our `}<a title='DeveloperResources' href="/document-services/resources/">{`Developer Resources`}</a>{`, `}<a title='QuickStart' href="https://developer.adobe.com/document-services/docs/overview/pdf-services-api/">{`Quickstart guide`}</a>{`, or `}<a title='TechSupportFaq' href="/document-services/faq/tech-support/">{`Tech Support FAQ.`}</a></p>
    <TextBlock slots="text, buttons" width="100%" theme="lightest" alignment="yes" primaryOutline className="padding-confiramtion text-align-left div-p-0  link linking how-it-work-richText support-explore-content-two confirmation-h-pad confirmation-content" mdxType="TextBlock" />
    <p>{`We also invite you to search for and ask your questions on our forums below.`}</p>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://community.adobe.com/t5/document-services-apis/ct-p/ct-Document-Cloud-SDK?filter=all&sort=latest_replies&tabid=discussions"
        }}>{`Ask on Forums`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/document-services/faq/tech-support/"
        }}>{`Visit FAQ`}</a></li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      